var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    [
      _c(
        "b-form-group",
        {
          staticClass: "is-valid",
          attrs: { id: "input-tag", label: "Nombre", "label-for": "txtName" },
        },
        [
          _c("b-form-input", {
            staticClass: "style2",
            attrs: {
              id: "txtName",
              type: "text",
              disabled: !_vm.editMode || _vm.updating,
            },
            model: {
              value: _vm.tagCopy.name,
              callback: function ($$v) {
                _vm.$set(
                  _vm.tagCopy,
                  "name",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "tagCopy.name",
            },
          }),
        ],
        1
      ),
      _vm.error
        ? _c("b-form-invalid-feedback", [_vm._v(" El nombre es obligatorio ")])
        : _vm._e(),
      _c(
        "b-form-group",
        {
          staticClass: "is-valid",
          attrs: {
            id: "input-color-tag",
            label: "Color",
            "label-for": "txtColor",
          },
        },
        [
          _c("b-form-input", {
            staticClass: "style2 w-25",
            attrs: {
              id: "txtColor",
              type: "color",
              disabled: !_vm.editMode || _vm.updating,
            },
            model: {
              value: _vm.tagCopy.color,
              callback: function ($$v) {
                _vm.$set(_vm.tagCopy, "color", $$v)
              },
              expression: "tagCopy.color",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-wrap justify-content-end align-items-center btn-wrap",
        },
        [
          _c(
            "b-button",
            {
              attrs: { type: "button", disabled: _vm.updating },
              on: {
                click: function ($event) {
                  return _vm.$router.back()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("lang.buttons.back")))]
          ),
          _vm.editMode
            ? [
                _c(
                  "b-button",
                  {
                    attrs: { disabled: _vm.updating },
                    on: { click: _vm.handleSaveClick },
                  },
                  [
                    _vm._v(_vm._s(_vm.$t("lang.buttons.confirm")) + " "),
                    _vm.updating
                      ? [
                          _c("b-spinner", {
                            attrs: {
                              variant: "primary",
                              label: "Spinning",
                              small: "",
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }